<template>
  <div class="sidebar" :class="{ 'mobile-open': isMobileOpen }">
    <!-- Sidebar Header with Logo -->
    <div class="sidebar-header">
      <div class="brand">
        <div class="brand-icon">
          <i class="fas fa-folder"></i>
        </div>
        <span class="brand-text">My notifications</span>
      </div>
    </div>
    
    <!-- Navigation Menu -->
    <div class="sidebar-menu">
      <nav class="nav flex-column">
        <router-link 
          to="/dashboard" 
          class="nav-link" 
          :class="{ active: isActiveRoute('/dashboard') }"
          @click="handleNavClick"
        >
          <div class="nav-icon">
            <i class="fas fa-folder"></i>
          </div>
          <span class="nav-text">Expedientes</span>
        </router-link>
        
        <router-link 
          to="/notifications" 
          class="nav-link" 
          :class="{ active: isActiveRoute('/notifications') }"
          @click="handleNavClick"
        >
          <div class="nav-icon">
            <i class="fas fa-bell"></i>
          </div>
          <span class="nav-text">Notificaciones</span>
          <span v-if="notificationCount > 0" class="badge">{{ notificationCount }}</span>
        </router-link>
        
        <router-link 
          to="/settings" 
          class="nav-link" 
          :class="{ active: isActiveRoute('/settings') }"
          @click="handleNavClick"
        >
          <div class="nav-icon">
            <i class="fas fa-palette"></i>
          </div>
          <span class="nav-text">Apariencia</span>
        </router-link>
        
        <router-link 
          to="/payments" 
          class="nav-link" 
          :class="{ active: isActiveRoute('/payments') }"
          @click="handleNavClick"
        >
          <div class="nav-icon">
            <i class="fas fa-credit-card"></i>
          </div>
          <span class="nav-text">Pagos</span>
        </router-link>
        
        <!-- <router-link 
          to="/favorites" 
          class="nav-link" 
          :class="{ active: isActiveRoute('/favorites') }"
          @click="handleNavClick"
        >
          <div class="nav-icon">
            <i class="fas fa-star"></i>
          </div>
          <span class="nav-text">Favoritos</span>
        </router-link> -->
      </nav>
      
      <!-- Additional Menu Sections -->
      <!-- <div class="menu-section">
        <div class="menu-section-title">Email settings</div>
        <nav class="nav flex-column">
          <router-link to="/contacts" class="nav-link">
            <div class="nav-icon">
              <i class="fas fa-users"></i>
            </div>
            <span class="nav-text">Contacts</span>
          </router-link>
          
          <div class="nav-link" :class="{ expanded: myNotificationsExpanded }" @click="toggleMyNotifications">
            <div class="nav-icon">
              <i class="fas fa-bell"></i>
            </div>
            <span class="nav-text">My notifications</span>
            <i class="fas fa-chevron-down expand-arrow" :class="{ rotated: myNotificationsExpanded }"></i>
          </div>
          
          <div class="submenu" v-show="myNotificationsExpanded">
            <router-link to="/profile-details" class="nav-link submenu-item">
              <div class="nav-icon">
                <i class="fas fa-user"></i>
              </div>
              <span class="nav-text">Profile details</span>
            </router-link>
            <router-link to="/notification-settings" class="nav-link submenu-item">
              <div class="nav-icon">
                <i class="fas fa-cog"></i>
              </div>
              <span class="nav-text">Notification</span>
            </router-link>
            <router-link to="/archived" class="nav-link submenu-item">
              <div class="nav-icon">
                <i class="fas fa-archive"></i>
              </div>
              <span class="nav-text">Archived</span>
            </router-link>
          </div>
          
          <router-link to="/recent" class="nav-link">
            <div class="nav-icon">
              <i class="fas fa-clock"></i>
            </div>
            <span class="nav-text">Recent</span>
            <span class="badge purple">2</span>
          </router-link>
          
          <router-link to="/favorites-menu" class="nav-link">
            <div class="nav-icon">
              <i class="fas fa-star"></i>
            </div>
            <span class="nav-text">Favorites</span>
          </router-link>
        </nav>
      </div> -->
    </div>
    
    <!-- Sidebar Footer -->
    <div class="sidebar-footer">
      <div class="upgrade-section">
        <div class="upgrade-info">
          <i class="fas fa-bell upgrade-icon"></i>
          <span class="upgrade-text">43% used</span>
        </div>
        <button class="upgrade-btn">Upgrade notifications</button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'SideBar',
  props: {
    isMobileOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myNotificationsExpanded: false
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'stateUser']),
    userName() {
      return this.stateUser ? `${this.stateUser.first_name} ${this.stateUser.last_name}` : '';
    },
    userEmail() {
      return this.stateUser ? this.stateUser.email : '';
    },
    notificationCount() {
      // You can implement notification count logic here
      return 3; // placeholder
    }
  },
  methods: {
    isActiveRoute(route) {
      return this.$route.path.startsWith(route);
    },
    toggleMyNotifications() {
      this.myNotificationsExpanded = !this.myNotificationsExpanded;
    },
    async logout() {
      await this.$store.dispatch('logOut');
      this.$router.push('/');
    },
    handleNavClick() {
      // Only emit on mobile
      if (window.innerWidth <= 768) {
        this.$emit('close-sidebar');
      }
    }
  }
});
</script>

<style scoped>
.sidebar {
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  color: white;
  height: 100vh;
  width: 280px;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
  z-index: 1000;
  overflow-y: auto;
}

.sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.brand {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
}

.brand-icon {
  margin-right: 0.75rem;
}

.brand-text {
  color: white;
}

.sidebar-menu {
  flex: 1;
  padding: 1rem 0;
}

.menu-section {
  margin-top: 2rem;
}

.menu-section-title {
  padding: 0.5rem 1.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(255,255,255,0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 0;
  position: relative;
  cursor: pointer;
}

.nav-link:hover {
  background: rgba(255,255,255,0.1);
  color: white;
  transform: translateX(5px);
  text-decoration: none;
}

.nav-link.active {
  background: rgba(255,255,255,0.15);
  color: white;
  border-right: 3px solid #ffd700;
}

.nav-link.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #ffd700;
}

.nav-icon {
  width: 20px;
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-icon i {
  font-size: 1.1rem;
}

.nav-text {
  flex: 1;
}

.expand-arrow {
  margin-left: auto;
  transition: transform 0.3s ease;
  font-size: 0.8rem;
}

.expand-arrow.rotated {
  transform: rotate(180deg);
}

.submenu {
  background: rgba(0,0,0,0.1);
}

.submenu-item {
  padding-left: 3rem;
  font-size: 0.9rem;
}

.badge {
  background: #ff4757;
  color: white;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  margin-left: auto;
  min-width: 20px;
  text-align: center;
}

.badge.purple {
  background: #8e44ad;
}

.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.upgrade-section {
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
}

.upgrade-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.upgrade-icon {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

.upgrade-text {
  font-size: 0.9rem;
  color: rgba(255,255,255,0.9);
}

.upgrade-btn {
  background: rgba(255,255,255,0.2);
  color: white;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.upgrade-btn:hover {
  background: rgba(255,255,255,0.3);
  border-color: rgba(255,255,255,0.5);
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 1001;
  }
  
  .sidebar.mobile-open {
    transform: translateX(0);
  }
}
</style>